import { parse } from '@sequencehq/utils/dates'
import { getScheduleChangeDateBounds } from '@sequencehq/utils'

const API_DATE_FORMAT = 'yyyy-MM-dd'

/**
 * The API types say every schedule has an end date, but an open ended one
 * doesn't, so it's optional here.
 */
type Schedule = {
  startDate: string
  endDate?: string
}

/**
 * The same bounds as the amendment modal's custom date picker. An amendment
 * can't take effect before today, because billing can't correct what it has
 * already invoiced. The maximum is `null` rather than `undefined` for an
 * open-ended schedule, because `DateControl` falls back to a default maximum
 * when it's left undefined.
 */
export const getAmendmentEffectiveFromBounds = (schedule: Schedule) => {
  const bounds = getScheduleChangeDateBounds({
    startDate: parseApiDate(schedule.startDate),
    endDate: parseApiEndDate(schedule.endDate),
    nextBillingDate: undefined
  })

  return {
    minDate: bounds.minimumCustomDate,
    maxDate: bounds.maximumCustomDate ?? null
  }
}

const parseApiDate = (date: string) => parse(date, API_DATE_FORMAT, new Date())

const parseApiEndDate = (date: string | undefined) =>
  date ? parseApiDate(date) : undefined
